














































import { Component, Vue } from 'vue-property-decorator';
import { ICalendar } from '@/interfaces';
import { AjaxHelper } from '@/AjaxHelper';

import List from '@/components/List.vue';
import ListItem from '@/components/ListItem.vue';
import Btn from '@/components/Btn.vue';
import Field from '@/components/Field.vue';
import TextField from '@/components/TextField.vue';

@Component({
  name: 'admin-calendars-page',
  components: { List, ListItem, Btn, Field, TextField },
  beforeRouteEnter: async (to, from, next) => {
    const calendars = await AjaxHelper.get('/calendar');
    next(vm => {
      (vm as any).calendars = calendars;
    });
  }
})
export default class AdminCalendarsComponent extends Vue {
  public calendars: ICalendar[] = [];
  public searchText = '';

  public get filteredCalendars(): ICalendar[] { return this.searchText.length > 0 ? this.calendars.filter(x => x.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) : this.calendars; }
}
